<template>
  <div class="custom-page" :class="className">
    <!-- 预览页面的custom-page -->
    <NavBar
      :style="{ '--color': color, '--bgcolor': bgcolor }"
      left-arrow
      :right-text="rightText"
      v-if="!noTitle"
      :class="{ 'no-border': noBorder }"
    >
      <template #title>
        <div class="title-img-wrapper" v-if="titleType === 'img'">
          <img
            style="height: 16px;"
            :src="require('@/assets/logo-white-title.png')"
            alt=""
          />
        </div>
        <div class="title-wrapper" v-else>
          <div class="title">{{ title }}</div>
          <div class="subtitle" v-if="subtitle">{{ subtitle }}</div>
        </div>
      </template>
    </NavBar>
    <div class="wrapper" :class="{ 'no-title': noTitle }">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant'
export default {
  components: { NavBar },
  props: {
    noBorder: {
      type: Boolean,
      default: false,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    },
    backRoute: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#fff',
    },
    bgcolor: {
      type: String,
      default: '#c82d26',
    },
    titleType: {
      type: String,
      default: null,
    },
    orderCenter: {
      type: String,
      default: null,
    },
  },
  methods: {
    onClickLeft() {
      if (this.orderCenter) {

        console.log('导航上', 1)
        this.$router.replace({
          path: '/mine/order',
          query: { active: 2, backRoute: 'Mine' },
        })
        return false
      }
      if (this.backRoute) {
        console.log('backRoute', 2)
        this.$router.push({ name: this.backRoute })
      } else {
        if (this.$route.query.customerId || this.$route.params.customerId) {
          this.$router.push({ name: 'Home' })
        } else {
          console.log('最下面', 3)
          this.$router.back()
        }
      }
    },
    onClickRight() {
      this.$emit('onClickRight')
    },
  },
}
</script>

<style lang="less" scoped>
.custom-page {
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  overflow: hidden;
  .van-nav-bar {
    background: var(--bgcolor);
    &.no-border::after {
      display: none;
    }
    /deep/ .van-nav-bar__content {
      height: 88px;
    }
    /deep/ .van-icon {
      color: var(--color);
    }
    /deep/ .van-nav-bar__title {
      color: #fff;
      font-size: 28px;
    }
    /deep/ .van-nav-bar__text {
      color: #fff;
      font-size: 28px;
    }
  }
  .title-wrapper {
    .title {
      font-size: 28px;
      color: var(--color);
      line-height: 32px;
    }
    .subtitle {
      font-size: 18px;
      color: var(--color);
      line-height: 28px;
    }
  }
  .wrapper {
    height: calc(100% - 88px);
    overflow-y: auto;
    text-align: left;
    &.no-title {
      height: 100%;
    }
  }
}
</style>
